import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import React, { useContext } from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import FieldSelect from "../../Table/FieldSelect"
import { useChildModalStyle } from "./style"
import Button from "@material-ui/core/Button"
import { useUpdate } from "./hooks"
import { AppContext } from "Views/Home/context"

const Update = () => {
    const classes = useChildModalStyle()
    const {
        callback, cancelCallback, dialogData, isPass, editCallback,
        disabled, dateStr, text, handleChange, handleChangeArticleType, external,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
    } = useUpdate()
    const { user } = useContext(AppContext)
    const { department: { type_name: typeName = '' } = {} } = user
    const isBusiness = typeName === 'business'
    const isMine = dialogData.board ? dialogData.board.creator_id === user.uid : false
    return (
        <BoardConfirmModal
            title="修改预约说明"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    disabled={isPass && isBusiness}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl disabled={isPass && isBusiness} className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        rowData={{
                            health_article_type_id: external.articleTypeId,
                        }}
                        staticValueList={[]}
                        tableName="health_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>

            {
                // 编辑时，用户为商务部成员且时自己的预约时，展示项目编号及金额
                isBusiness && isMine ? (
                    <>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center" className={classes.input}>
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                            />
                        </Grid>
                    </>
                ) : null
            }

            <Grid item>
                <div className={classes.materialBtn}>
                    <Button color="primary" onClick={editCallback}>编辑物料</Button>
                </div>
            </Grid>


        </BoardConfirmModal>
    )
}

export default Update
